import styled from '@emotion/styled';
import { ILinkStyledComponent } from '../../link.models';
import * as S from '../../link.style';
import { cssprops } from '@vfit/shared/themes';

export const Button = styled.button<ILinkStyledComponent>`
  border: none;
  cursor: pointer;
  padding: 0;
  ${({ variant }) => (variant === 'regular' ? 'text-decoration: underline;' : '')}
  ${S.common}
  &:disabled {
    ${S.disabled}
  }
  ${cssprops.styled as any}
`;